import { useNavigate } from 'react-router-dom'
import PuzzleCard from '../components/PuzzleCard'
import { PuzzleType } from '../types'

interface PuzzleEntry {
  type:         PuzzleType
  label:        string
  icon:         string
  description:  string
  accentClass:  string
  iconBgClass:  string
}

const PUZZLES: PuzzleEntry[] = [
  {
    type:         'sudoku',
    label:        'Sudoku',
    icon:         '🔢',
    description:  'Fill every row, column and box with the right numbers',
    accentClass:  'border-bubble-coral hover:bg-bubble-coral-light',
    iconBgClass:  'bg-bubble-coral-light',
  },
  {
    type:         'crossword',
    label:        'Crossword',
    icon:         '✏️',
    description:  'Solve word clues to fill the grid across and down',
    accentClass:  'border-bubble-teal hover:bg-bubble-teal-light',
    iconBgClass:  'bg-bubble-teal-light',
  },
  {
    type:         'rebus',
    label:        'Rebus',
    icon:         '🖼️',
    description:  'Decode picture puzzles to find the hidden word',
    accentClass:  'border-bubble-lemon hover:bg-bubble-lemon-light',
    iconBgClass:  'bg-bubble-lemon-light',
  },
  {
    type:         'maze',
    label:        'Maze',
    icon:         '🌀',
    description:  'Find the path from entrance to exit',
    accentClass:  'border-bubble-mint hover:bg-bubble-mint-light',
    iconBgClass:  'bg-bubble-mint-light',
  },
  {
    type:         'math',
    label:        'Math Puzzle',
    icon:         '➕',
    description:  'Solve arithmetic challenges — add, subtract, multiply and divide',
    accentClass:  'border-bubble-pink hover:bg-bubble-pink-light',
    iconBgClass:  'bg-bubble-pink-light',
  },
]

export default function Home() {
  const navigate = useNavigate()

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-display font-black text-4xl text-bubble-text mb-2">
          Choose a Puzzle
        </h1>
        <p className="text-bubble-muted text-lg">
          Pick a type and we'll set it up for you
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {PUZZLES.map((p) => (
          <PuzzleCard
            key={p.type}
            icon={p.icon}
            label={p.label}
            description={p.description}
            accentClass={p.accentClass}
            iconBgClass={p.iconBgClass}
            onClick={() => navigate(`/${p.type}`)}
          />
        ))}
      </div>
    </div>
  )
}
